import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import {fadeInAnimation} from "../../animations/fadeInAnimation";
import {WinOlsSolutionsService, WinOlsSolutionType} from "../../service/WinOlsSolutionsService";
import {WinOlsSolutionsModel} from "../../models/WinOlsSolutionsModel";

@Component({
  selector: 'app-win-ols-solutions-tcu-tuning',
  templateUrl: './win-ols-solutions-tcu-tuning.component.html',
  styleUrl: './win-ols-solutions-tcu-tuning.component.css',
  animations: [fadeInAnimation],
  host: {'[@fadeInAnimation]': ''},
})
export class WinOlsSolutionsTcuTuningComponent implements OnInit {
  public displayedColumns: string[] = ['tuningName', 'evcCredits', 'actions'];

    duplicateTuningName = false;
    duplicateTypeValue = '';

    @ViewChild('tableContainer', { static: false }) tableContainer!: ElementRef;

  constructor(public winOlsSolutionsService: WinOlsSolutionsService) {}

  ngOnInit() {
    this.winOlsSolutionsService.searchQuery.set('');
    this.winOlsSolutionsService.initializeForSolutionType(WinOlsSolutionType.TCU_TUNING);
    this.getSolutions();
  }

  getSolutions() {
    this.winOlsSolutionsService.getWinOlsSolutions();
  }

    toggleInputRow(): void {
        this.winOlsSolutionsService.showInputRow.set(!this.winOlsSolutionsService.showInputRow());
        this.winOlsSolutionsService.resetNewRowValue();
        this.resetDuplicateWarning();
        setTimeout(() => {
            this.tableContainer?.nativeElement?.scrollTo({ top: 0, behavior: 'smooth' });
        }, 0);
    }

    onNewTuningNameInput(value: string) {
        this.duplicateTypeValue = value;

        if (!value || !value.trim()) {
            this.duplicateTuningName = false;
            return;
        }

        const isDuplicate = this.winOlsSolutionsService.checkDuplicateTuningName(value);
        this.duplicateTuningName = isDuplicate;
    }


    addNewRow(): void {
        if (!this.winOlsSolutionsService.isValidSolution(this.winOlsSolutionsService.newRow())) {
            return;
        }

        this.winOlsSolutionsService.addNewWinOlsSolutionItem(this.winOlsSolutionsService.newRow());
        this.resetDuplicateWarning();

        setTimeout(() => {
            this.tableContainer?.nativeElement?.scrollTo({ top: 0, behavior: 'smooth' });
        }, 0);
    }

    onEditTuningNameInput(value: string, currentId: number) {
        if (value.trim().length === 0) {
            this.duplicateTuningName = false;
            this.duplicateTypeValue = '';
            return;
        }

        const isDuplicate = this.winOlsSolutionsService.checkDuplicateTuningName(value, currentId);

        this.duplicateTuningName = isDuplicate;
        this.duplicateTypeValue = isDuplicate ? value : '';
    }



    deleteRow() {
    this.winOlsSolutionsService.showInputRow.set(false);
    this.resetDuplicateWarning();
  }

  deleteItemFromDatabase(solution: WinOlsSolutionsModel) {
    this.winOlsSolutionsService.deleteWinOlsSolutionItem(solution);
  }

  editSolution(solutionIndex: number) {
    this.resetDuplicateWarning();
    this.winOlsSolutionsService.solutionToEditIndex.set(solutionIndex);
  }

  saveEditedItem(solution: WinOlsSolutionsModel, id: number) {
    this.winOlsSolutionsService.updateWinOlsSolution(solution, id);
  }

  searchForTuningNames(event: any) {
    this.searchSolutions(event.target.value);
  }

  searchForEvcCredits(event: any) {
    this.searchSolutions(event.target.value);
  }

  searchSolutions(searchQuery: string) {
    this.winOlsSolutionsService.searchSolutions(searchQuery);
  }

    onRefreshTable() {
        this.winOlsSolutionsService.onRefreshTable();
        this.resetDuplicateWarning();

        setTimeout(() => {
            if (this.tableContainer?.nativeElement) {
                this.tableContainer.nativeElement.scrollTo({ top: 0, behavior: 'smooth' });
            }
        }, 300);
    }

    private resetDuplicateWarning() {
        this.duplicateTuningName = false;
        this.duplicateTypeValue = '';
    }
}
